'use client';

import { type RoadMapUpdate } from '@/domain/roadmap/types';
import { useUsers } from '@/domain/user/hooks';
import { type UserBrief } from '@/domain/user/types';
import { useAuth } from '@/hooks/useAuth';
import { Autocomplete } from '@andritzot/metris-web-ui/inputs/autocomplete';
import { Button } from '@andritzot/metris-web-ui/inputs/button';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { Grid } from '@andritzot/metris-web-ui/layout/grid';
import { type Control, Controller } from 'react-hook-form';

import { FieldActionsWrapper } from './shared/FieldActionsWrapper';

interface OwnerFieldProps {
  viewOnly: boolean;
  control: Control<RoadMapUpdate, unknown>;
}

export function OwnerField({ viewOnly, control }: Readonly<OwnerFieldProps>) {
  const { user } = useAuth();
  const { data: users } = useUsers({ enabled: !!user });

  return (
    <Box sx={{ py: 0.75, width: '100%' }}>
      <Controller
        name="owner"
        control={control}
        render={({ field: { value, onChange } }) => (
          <FieldActionsWrapper>
            <Grid container spacing={2} alignItems="center">
              <Grid size={6}>
                <Autocomplete<UserBrief, false, false, false>
                  value={value ?? null}
                  onChange={(_, newValue) => onChange(newValue)}
                  options={users ?? []}
                  getOptionLabel={(u) => u.name}
                  getOptionKey={(u) => u.idUser}
                  isOptionEqualToValue={(opt, v) => opt.idUser === v.idUser}
                  label="Owner"
                  placeholder="Search users..."
                  disabled={viewOnly}
                  fullWidth
                  size="small"
                />
              </Grid>
              {!viewOnly && (
                <Grid size={6}>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => {
                      const me = users?.find((u) => u.idUser === user?.idUser);
                      if (me) onChange(me);
                    }}
                    disabled={value?.idUser === user?.idUser}
                  >
                    Assign to me
                  </Button>
                </Grid>
              )}
            </Grid>
          </FieldActionsWrapper>
        )}
      />
    </Box>
  );
}
